import { render, staticRenderFns } from "./EditGuesthouse.vue?vue&type=template&id=5fb620ed"
import script from "./EditGuesthouse.vue?vue&type=script&lang=js"
export * from "./EditGuesthouse.vue?vue&type=script&lang=js"
import style0 from "./EditGuesthouse.vue?vue&type=style&index=0&id=5fb620ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports